import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=62c37a38&scoped=true"
import script from "./Footer.js?vue&type=script&lang=js&external"
export * from "./Footer.js?vue&type=script&lang=js&external"
import style0 from "./Footer.scss?vue&type=style&index=0&id=62c37a38&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c37a38",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotBreadcrumb: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Molecules/Breadcrumb/Breadcrumb.vue').default,HotLink: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Link/Link.vue').default,HotLanguageSwitch: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Molecules/LanguageSwitch/LanguageSwitch.vue').default,HotMadeWithLove: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Molecules/MadeWithLove/MadeWithLove.vue').default,HotSocialIcons: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Molecules/SocialIcons/SocialIcons.vue').default,HotImage: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Image/Image.vue').default})
